import React, { useState } from "react";

// import { Link } from "react-router-dom";

function Penjualan() {
  return <div className="h-[86%]"></div>;
}

export default Penjualan;
